export const messages = {
    "wre-dashboard.nav-menu.item.shared": "Chia sẻ",
    "wre-dashboard.nav-menu.item.backups": "Bản sao lưu",
    "wre-dashboard.nav-menu.item.machines": "Máy",
    "wre-dashboard.nav-menu.item.account": "Tài khoản",
    "wre-dashboard.search.input.hint": "Tìm kiếm",
    "wre-dashboard.search.label.breadcrumb": "Kết quả tìm kiếm",
    "wre-dashboard.search.message.empty": "Không có mục nào khớp với nội dung tìm kiếm của bạn",
    "wre-dashboard.side-bar.selected.title:plural": "Đã chọn {count} mục | Đã chọn {count} mục",
    "wre-dashboard.side-bar.backup-type.disk": "Ổ đĩa",
    "wre-dashboard.side-bar.backup-type.file": "Tệp",
    "wre-dashboard.side-bar.backup-type.notarized": "Tệp và thư mục được chứng thực",
    "wre-dashboard.side-bar.backup-type.exchange": "Ứng dụng - Microsoft Exchange",
    "wre-dashboard.side-bar.backup-type.sql": "Ứng dụng - Microsoft SQL",
    "wre-dashboard.side-bar.backup-type.sys-state": "Ứng dụng - Trạng thái hệ thống",
    "wre-dashboard.side-bar.backup-type.application": "Ứng dụng",
    "wre-dashboard.space-indicator.label.left": "Còn {spaceFree}",
    "wre-dashboard.space-indicator.label.used": "Đã sử dụng {usedSpace}",
    "wre-dashboard.space-indicator.label.unlimited": "Không giới hạn",
    "wre-dashboard.backups-table.column.name": "Tên",
    "wre-dashboard.backups-table.column.size": "Kích cỡ",
    "wre-dashboard.backups-table.column.version": "Bản sao lưu gần nhất",
    "wre-dashboard.backups-table.message.no-backups": "Chưa có bản sao lưu nào trong Đám mây",
    "wre-dashboard.backups-sidebar.label.size": "Kích cỡ",
    "wre-dashboard.backups-sidebar.label.type": "Loại",
    "wre-dashboard.backups-sidebar.label.version": "Phiên bản gần nhất",
    "wre-dashboard.backups-sidebar.label.created": "Đã tạo",
    "wre-dashboard.backups-sidebar.label.machine": "Máy",
    "wre-dashboard.backups-sidebar.label.owner": "Chủ sở hữu",
    "wre-dashboard.content-table.column.name": "Tên",
    "wre-dashboard.content-table.column.versions": "Phiên bản",
    "wre-dashboard.content-table.column.volumes": "Khu vực lưu trữ",
    "wre-dashboard.content-table.column.path": "Đường dẫn",
    "wre-dashboard.content-table.column.size": "Kích cỡ",
    "wre-dashboard.content-table.column.version": "Phiên bản gần nhất",
    "wre-dashboard.content-table.action.versions": "Phiên bản",
    "wre-dashboard.content-table.action.restore": "Tải xuống",
    "wre-dashboard.content-table.action.share": "Chia sẻ liên kết",
    "wre-dashboard.content-table.label.size": "Kích cỡ",
    "wre-dashboard.content-table.label.created": "Đã tạo",
    "wre-dashboard.content-table.label.modified": "Đã sửa đổi",
    "wre-dashboard.content-table.message.empty-folder": "Thư mục này trống",
    "wre-dashboard.password-dialog-box.title.backup": "Bản sao lưu được mã hóa",
    "wre-dashboard.password-dialog-box.title.archive": "Bản lưu trữ được mã hóa",
    "wre-dashboard.password-dialog-box.message.backup": "Vui lòng cho biết mật khẩu để truy cập bản sao lưu {displayName}",
    "wre-dashboard.password-dialog-box.message.archive": "Vui lòng cho biết mật khẩu để truy cập bản lưu trữ {displayName}",
    "wre-dashboard.password-dialog-box.hint.password": "Mật khẩu",
    "wre-dashboard.password-dialog-box.message.invalid-password": "Mật khẩu không chính xác",
    "wre-dashboard.form.button.open": "Mở",
    "wre-dashboard.form.button.close": "Đóng",
    "wre-dashboard.form.button.cancel": "Hủy",
    "wre-dashboard.form.button.delete": "Xóa",
    "wre-dashboard.shared-content-table.column.name": "Tên",
    "wre-dashboard.shared-content-table.column.location": "Vị trí",
    "wre-dashboard.shared-content-table.column.source": "Nguồn",
    "wre-dashboard.shared-content-table.column.days": "Ngày",
    "wre-dashboard.shared-content-table.column.downloads": "Nội dung tải xuống",
    "wre-dashboard.shared-content-table.column.shared": "Đã chia sẻ vào",
    "wre-dashboard.shared-content-table.label.shared": "Đã chia sẻ vào",
    "wre-dashboard.shared-content-table.label.backup": "Nguồn",
    "wre-dashboard.shared-content-table.action.share": "Chia sẻ liên kết",
    "wre-dashboard.shared-content-table.action.settings": "Cài đặt liên kết",
    "wre-dashboard.shared-content-table.action.delete": "Xóa liên kết",
    "wre-dashboard.shared-content-table.action.delete-selected": "Xóa liên kết",
    "wre-dashboard.account-page.message.used-space": "{brandName}: Còn trống {spaceFree}/{totalSpace}",
    "wre-dashboard.account-page.message.used-unlimited-space": "{brandName}: Không gian không giới hạn",
    "wre-dashboard.account-page.button.sign-out": "Đăng xuất",
    "wre-dashboard.account-page.button.manage-subscription": "Quản lý giấy phép",
    "wre-dashboard.account-page.message.subscription.active": "Giấy phép sử dụng không gian {brandName} của bạn sẽ hết hạn vào",
    "wre-dashboard.account-page.message.subscription.trial": "Bản dùng thử {brandName} sẽ hoạt động cho đến",
    "wre-dashboard.account-page.message.subscription.expired": "Giấy phép sử dụng không gian {brandName} của bạn đã hết hạn vào",
    "wre-dashboard.account-page.message.worm-status.storage-full": "Bộ nhớ {brandName} của bạn đã đầy. Bạn không thể sao lưu hoặc lưu trữ dữ liệu trên đám mây.",
    "wre-dashboard.account-page.message.worm-status.less-than": "Còn trống chưa đến {percent}%. Bạn sẽ sớm không thể sử dụng {brandName}.",
    "wre-dashboard.versions-dialog-box.title": "Phiên bản của {fileName}",
    "wre-dashboard.shared-link-dialog-box.share-view.button.copy": "Sao chép liên kết",
    "wre-dashboard.shared-link-dialog-box.share-view.button.manage": "Cài đặt liên kết",
    "wre-dashboard.shared-link-dialog-box.share-view.message": "Bất kỳ ai có liên kết này đều có thể xem phiên bản gần nhất của dữ liệu",
    "wre-dashboard.shared-link-dialog-box.share-view.label.shared": "Đã chia sẻ vào {creationDate}",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copied": "Đã sao chép liên kết",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copy-error": "Lỗi sao chép liên kết",
    "wre-dashboard.shared-link-dialog-box.delete-view.title": "Xóa liên kết",
    "wre-dashboard.shared-link-dialog-box.delete-view.message": "Liên kết này sẽ không còn hoạt động với những người có liên kết",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.title": "Xóa liên kết",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.message": "Những liên kết này sẽ dừng hoạt động với những người có liên kết",
    "wre-dashboard.shared-link-dialog-box.manage-view.title": "Cài đặt liên kết",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.delete": "Xóa liên kết",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.apply": "Xong",
    "wre-dashboard.shared-link-dialog-box.manage-view.input.hint.password": "Mật khẩu",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.reset-password": "Đặt lại mật khẩu",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.password-protection": "Bảo vệ bằng mật khẩu",
    "wre-dashboard.shared-link-dialog-box.manage-view.message.protect-by-password": "Bảo vệ liên kết này bằng cách dùng mật khẩu",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.expiration": "Thời hạn",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.download-limits": "Giới hạn lượt tải xuống",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-in:plural": "Vô hiệu hóa liên kết này trong {splitMarker} ngày | Vô hiệu hóa liên kết này trong {splitMarker} ngày",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-after:plural": "Vô hiệu hóa liên kết này sau {splitMarker} lượt tải xuống | Vô hiệu hóa liên kết này sau {splitMarker} lượt tải xuống",
    "wre-dashboard.sub-accounts-dialog-box.title": "Tài khoản",
    "wre-dashboard.sub-accounts-dialog-box.search.input.hint": "Tìm kiếm",
    "wre-dashboard.sub-accounts-dialog-box.table.message.empty": "Không có mục nào khớp với nội dung tìm kiếm của bạn",
    "wre-dashboard.sub-accounts-dialog-box.table.column.name": "Tên",
    "wre-dashboard.sub-accounts-dialog-box.table.column.usage": "Mức sử dụng",
    "wre-dashboard.sub-accounts-dialog-box.table.column.version": "Lần sao lưu gần nhất",
    "wre-dashboard.sub-accounts-dialog-box.table.column.expires": "Hết hạn",
    "wre-dashboard.sub-accounts-dialog-box.label.used-space": "Còn trống {spaceFree} / {totalSpace}",
    "wre-dashboard.sub-accounts-dialog-box.label.volume-subscription": "Gói đăng ký số lượng lớn",
    "wre-dashboard.sub-accounts-dialog-box.label.expired": "Đã hết hạn",
    "wre-dashboard.machines-table.column.name": "Tên",
    "wre-dashboard.machines-table.column.size": "Kích cỡ",
    "wre-dashboard.machines-table.message.no-machines": "Chưa có máy nào trong Đám mây"
};
